import { connect } from "react-redux"
import React, { Component } from 'react'
import ShapeType, { BADGE_TYPE } from "shape-entities/types/shape"
import { Project, ShapeSet, ShapeSetFile } from "app/types/model-types"
import trans from "trans";
import { Button, css, GridCell, Icon, Message, Theme } from "@bdfx/mergado-ui-kit";
import { ShapeGrid } from "shape-edit/components/shape-selection";
import { testUsers } from "template-edit/components/helper"
import { iconDisabledColor } from "template-edit/components/tools-panel"
import { find } from "lodash"
import { selectFormValue } from "app/reducers/form";
import { getFormName, getTemplateSize, reorderShapes } from "./helpers";
import { setActiveShapeId, setActiveView } from "shape-edit/reducers";
import { URL } from "app/config/api-config";

import SetSelectionItem from "shape-edit/components/set-selection-item";
import { ACTIVE_VIEW_EDIT_SHAPE, ACTIVE_VIEW_NEW_SHAPE } from "template-edit/containers/Editor";
import getShape from "shape-entities/defaults";
import BadgeForm from "./badge-form";

import {
    updateInputValue as change,
} from "app/reducers/form";

const EXCLUDE_SETS_FROM_MENU = ['background', 'generic']
const SETS_IN_MENU = ['borders', 'emoji', 'rating', 'tags', 'free-delivery', 'black-friday', 'valentine', 'easter', 'summer', 'autumn', 'winter']

interface Props {
    shape: ShapeType
    search: string
    isSearching: boolean
    change: typeof change
    setSearching: (isSearching: boolean) => void
    toggleSwitch: () => void
    isAlt: boolean
    project: Project
    shapes: ShapeType[]
    shapeSets: ShapeSet[]
    setActiveShapeId: typeof setActiveShapeId
    setActiveView: typeof setActiveView
}

interface State {
    showMore: boolean
}

class BadgesForm extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            showMore: false,
        }
    }

    selectShape = (shapeSet: ShapeSet = null) => {
        const { shape, isAlt } = this.props

        const formName = getFormName(isAlt)
        const templateSize = getTemplateSize()

        const updatedShape: ShapeType = {
            ...shape,
            type: BADGE_TYPE,
            width: templateSize.width,
            height: templateSize.height,
            set_id: shapeSet ? parseInt(shapeSet.id.toString()) : null,
            set_file_id: null,
            imageBlob: null,
            set: shapeSet,
            external_image_prompt: null,
        }

        this.props.change(formName, `shapes.${shape.index}`, updatedShape)
    }

    selectSet = (shapeSet: ShapeSet) => {
        this.selectShape(shapeSet)
    }

    getMatchingSetFiles = (): { set: ShapeSet, file: ShapeSetFile }[] => {
        const { shapeSets, search } = this.props

        if (!search) {
            return []
        }

        const term = search.toLowerCase()
        const matches: { set: ShapeSet, file: ShapeSetFile }[] = []

        shapeSets.forEach((shapeSet: ShapeSet) => {
            (shapeSet.files || []).forEach((file: ShapeSetFile) => {
                if (file.tags && file.tags.toLowerCase().includes(term)) {
                    matches.push({ set: shapeSet, file })
                }
            })
        })

        return matches
    }

    selectSetFile = (shapeSet: ShapeSet, setFile: ShapeSetFile) => {
        const { shapes } = this.props

        const templateSize = getTemplateSize()

        let newShape: ShapeType = getShape(BADGE_TYPE, {
            width: templateSize.width,
            height: templateSize.height,
        }, 0)

        newShape.set_id = parseInt(shapeSet.id.toString())
        newShape.set = shapeSet
        newShape.set_file_id = parseInt(setFile.id.toString())
        newShape.name = `${shapeSet.name} ${setFile.filename}`
        //newShape.width = setFile.width


        const finishSelection = (imageBlob: string) => {
            newShape.imageBlob = imageBlob

            //reorder shapes and set priority here:
            let newShapes = [];
            newShapes[newShape.index] = newShape
            const allNewShapes = { ...newShapes, ...shapes }

            //reorderShapes omits badges without a set_file_id unless activeView is ACTIVE_VIEW_NEW_SHAPE, so switch to it first:
            this.props.setActiveView(ACTIVE_VIEW_NEW_SHAPE)
            const newIndexOrder = [newShape.index, ...Object.keys(shapes)]
            reorderShapes(allNewShapes, newIndexOrder)

            this.props.setActiveView(ACTIVE_VIEW_EDIT_SHAPE)
            this.props.setActiveShapeId(newShape.index)
        }

        if (setFile.mime_type === 'jpeg') {
            finishSelection(`${URL.laravelBase}imagesets/${shapeSet.name}/${setFile.filename}`)
        } else {
            const path = `${URL.publicPath}img/sets/${shapeSet.name}/${setFile.filename}`

            const request = new XMLHttpRequest()
            request.open('GET', path.replace('.png', '.svg'))
            request.setRequestHeader('Content-Type', 'image/svg+xml')
            request.addEventListener('load', (event) => {
                const eventTarget: any = event.target
                finishSelection('data:image/svg+xml,' + encodeURIComponent(eventTarget.responseText))
            })
            request.send()
        }
    }

    render() {
        const { shapeSets, project, search, shape } = this.props
        const { showMore } = this.state
        const userId = project.user && project.user.id ? project.user.id : null

        const matchingSetFiles = search ? this.getMatchingSetFiles() : []

        return <StyledDiv>
            {search &&
                <React.Fragment>
                    <div className="form-title">{trans('results')}</div>

                    {matchingSetFiles.length ?
                        <ShapeGrid cols="repeat(auto-fit, minmax(100px, 1fr))" gap={"10px"}>
                            {matchingSetFiles.map(({ set, file }) =>
                                <Button
                                    secondary={true}
                                    key={`setfile${file.id}`}
                                    title={file.tags}
                                    onClick={() => this.selectSetFile(set, file)}>
                                    <div className={'thumb-wrapper'}>
                                        <img src={`${URL.publicPath}img/sets/${set.name}/${file.filename}`} width={32} />
                                    </div>
                                    <div className={'muk-icon__text'}>{trans(set.name)}</div>
                                </Button>
                            )}
                        </ShapeGrid> :
                        <Message type={"info"} closeable={true} icon={<Icon type={'info'} color={Theme.blue} size={28} />}>{trans("no_search_image_results")}</Message>
                    }
                </React.Fragment>
            }

            <BadgeForm shapeIndex={shape.index} />

            <ShapeGrid cols="repeat(auto-fit, minmax(100px, 1fr))" gap={"10px"}>
                {/* {shapeSets
                    .filter(shapeSet => !EXCLUDE_SETS_FROM_MENU.includes(shapeSet.name)) //filter out background shape set
                    .map(shapeSet => <SetSelectionItem data={shapeSet} key={`shapeset${shapeSet.id}`} onClick={() => this.selectSet(shapeSet)} />)
                } */}

                {SETS_IN_MENU.map(setName => {
                    const shapeSet: ShapeSet = find(shapeSets, (set) => set.name === setName)
                    return <SetSelectionItem data={shapeSet} key={`shapeset${shapeSet.id}`} onClick={() => this.selectSet(shapeSet)} />
                })}

                {userId && testUsers.includes(userId) &&
                    <React.Fragment>
                        <Button
                            type={'void'}
                            secondary={true}
                            style={{
                                alignSelf: 'center',
                                textAlign: 'center',
                                border: '0 !important',
                            }}
                            className="some-users-only"
                            onClick={() => this.setState({ showMore: !showMore })}>
                            <div className={'thumb-wrapper'} style={{ border: 0 }}>
                                <Icon
                                    type={!showMore ? 'double-arrow-right-radix' : 'double-arrow-left-radix'}
                                    size={32}
                                    color={!showMore ? iconDisabledColor : Theme.steelblue}
                                />
                            </div>
                            <div className={'muk-icon__text'}>{trans(!showMore ? 'more' : 'less')}</div>
                        </Button>
                    </React.Fragment>
                }
                <GridCell col={'1/-1'} style={{ textAlign: 'center', marginTop: '20px' }}>
                    {trans('did_not_found_stickers')} <span style={{
                        color: Theme.blue,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }} onClick={() => this.props.toggleSwitch()}>{trans('try_icons')}</span>
                </GridCell>
            </ShapeGrid>
        </StyledDiv>
    }
}

const StyledDiv = css('div')({
    ' .form-title': {
        marginTop: '20px',
        textTransform: 'uppercase',
        fontSize: 'small',
        color: iconDisabledColor,
    }
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        shapes: selectFormValue(state, getFormName(state.isAlt), 'shapes'),
        shapeSets: state.shapeSets.data,
        project: state.project.data,
    }
}

export default connect(mapStateToProps, {
    change,
    setActiveView,
    setActiveShapeId,
})(BadgesForm)
